const mode = import.meta.env.MODE;

export const isDevMode = mode === "development";
console.log({ mode });
